import React from 'react';
import { Link } from 'react-router-dom';
import MockupShell from './MockupShell';

const TILES = [
  { to: '/mockups/dashboard',    label: 'Member Dashboard',         desc: 'Personal home: status, referral link, PIF queue, credits, training, activity.' },
  { to: '/mockups/global-pif',   label: 'Global PIF List',          desc: 'Public queue of prospects available to be claimed via Pay-It-Forward.' },
  { to: '/mockups/personal-pif', label: 'Personal PIF Queue',       desc: 'Your private prospect window — claim before they release to the network.' },
  { to: '/mockups/link-file',    label: 'Link File',                desc: 'Organize referral, lead-capture, rotator, social, and campaign links.' },
  { to: '/mockups/rotator',      label: 'Rotator / Split-Test',     desc: 'Round-robin/weight-based redirect tool with click counts.' },
  { to: '/mockups/safe-list',    label: 'Safe List / Mailer',       desc: 'Internal mailing tool with credits, inbox preview, and compliance rules.' },
  { to: '/mockups/credits',      label: 'Credit Wallet',            desc: 'Five-type unified credit ledger: earned, granted, used, expired.' },
  { to: '/mockups/training',     label: 'Training Vault',           desc: 'Founder training modules with progress tracking and gated content.' },
  { to: '/mockups/lead-capture', label: 'Lead Capture Templates',   desc: 'Pre-built lead pages members can clone, customize, and publish.' },
  { to: '/mockups/tools',        label: 'Tools / Services Hub',     desc: 'All member tools in one place. Some live, some locked/coming soon.' },
];

export default function MockupIndex() {
  return (
    <MockupShell
      title="Builder Back-Office — Visual Mockups"
      subtitle="Click any page to walk through the post-launch member experience. Seeded demo data only."
      dataTestId="mockup-index"
    >
      <div className="mk-compliance" style={{ marginBottom: 18 }}>
        <strong>For video / onboarding use.</strong> These screens illustrate the BBC Quick List
        member back-office. All numbers, names, and balances on these pages are sample data — they
        do not represent any real prospect, member, or transaction.
      </div>

      <div className="mk-grid mk-grid--2" data-testid="mockup-index-grid">
        {TILES.map((t) => (
          <Link key={t.to} to={t.to} className="mk-card" data-testid={`mockup-tile-${t.to.split('/').pop()}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <h3 style={{ margin: 0 }}>{t.label}</h3>
              <span className="mk-badge mk-badge--gold">Preview</span>
            </div>
            <p style={{ margin: 0, fontSize: 13, color: 'var(--mk-muted)', lineHeight: 1.55 }}>{t.desc}</p>
          </Link>
        ))}
      </div>
    </MockupShell>
  );
}
